
export function linksSection() {
    let linksSection = document.querySelector(".links-section");
    let linkButton = linksSection.querySelector(".links-section-button");
    let counstItems = () => {
        let linksSectionHolder = linksSection.querySelector(".links-section-holder").offsetHeight;
        let linksSectionList = linksSection.querySelector(".scroll-list").offsetHeight;
        let isHideButton = linksSectionList - linksSectionHolder === 0;

        if (isHideButton) {
            linksSection.classList.add("hide-button");
        } else {
            linksSection.classList.remove("hide-button");
        }
    };

    linkButton.addEventListener("click", function (e) {
        e.preventDefault();
        linksSection.classList.toggle("active");
    });

    document.addEventListener("click",  function (e) {
        let container = linksSection.querySelector(".links-section-holder");
        if (!container.contains(e.target)) {
            linksSection.classList.remove("active");
        }
    });

    window.addEventListener("resize", (e) => {
        counstItems()
    });
    window.addEventListener("load", (e) => {
        counstItems()
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/linksSection.js